<template>
  <div
    class="variations"
  >
    <div
      v-if="showTitle"
      class="variations__heading"
    >
      <template v-if="product?.color?.label">
        <span class="label">{{ $t('Color') }}</span>
        <span class="data">{{ product?.color?.label }}</span>
      </template>
      <template v-else>
        <span class="label">{{ $t('Choose your color') }}</span>
      </template>
    </div>

    <div class="variations__content">
      <ul class="variations__list">
        <li class="variations__item">
          <span class="variations__link current">
            <span class="variations__visual">
              <img
                :src="productImageUrl(product?.image, '?f=rs:fit:48:64', product?.name)"
                width="48"
                height="64"
                :alt="product?.name"
                loading="lazy"
                class="variations__image"
              >
            </span>
          </span>
        </li>
        <li
          v-for="item in relatedColorProducts.slice(0, limit) || []"
          :key="item.id"
          class="variations__item"
        >
          <AppLink
            :to="link(item)"
            class="variations__link"
          >
            <span class="variations__visual">
              <img
                :src="productImageUrl(item.image, '?f=rs:fit:48:64', item.name)"
                width="48"
                height="64"
                :alt="item.name"
                loading="lazy"
                class="variations__image"
              >
            </span>
          </AppLink>
        </li>
      </ul>
      <button
        v-if="relatedColorProducts.length > limit"
        type="button"
        class="variations__more"
        @click="enablePopup && modalColors.open()"
      >
        +{{ relatedColorProducts.length - limit }}
      </button>
    </div>

    <LazyUiDialog
      v-if="enablePopup"
      class="variants__modal"
      name="modal-colors"
      dialog-type="responsive"
    >
      <template #dialogHeader>
        {{ $t('Choose your color') }}
      </template>

      <ul class="modal-colors__content">
        <li class="variations__item">
          <span class="variations__link current">
            <span class="variations__visual">
              <img
                :src="productImageUrl(product?.image, '?f=rs:fit:96:171', product?.name)"
                width="128"
                height="171"
                :alt="product?.name"
                loading="lazy"
                class="variations__image"
              >
            </span>

            <span class="variations__label">{{ product?.color?.label }}</span>
          </span>
        </li>
        <li
          v-for="item in relatedColorProducts || []"
          :key="item.sku"
          class="variations__item"
        >
          <AppLink
            :to="link(item)"
            class="variations__link"
            @click="modalColors.close"
          >
            <span class="variations__visual">
              <img
                :src="productImageUrl(item.image, '?f=rs:fit:128:171', item.name)"
                width="128"
                height="171"
                :alt="item.name"
                loading="lazy"
                class="variations__image"
              >
            </span>

            <span class="variations__label">
              {{ item?.color?.label }}
            </span>
          </AppLink>
        </li>
      </ul>
    </LazyUiDialog>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    product: any
    showTitle?: boolean
    limit?: number
    enablePopup?: boolean
  }>(),
  {
    showTitle: true,
    limit: 5,
    enablePopup: true,
  },
)

const limit = props.limit
const modalColors = useUiDialog('modal-colors')

const relatedColorProducts = computed(() => {
  return props.product?.relatedColorProducts?.filter(item => item?.product).map(item => item.product)
})

const productImageUrl = (url: string, params: string) => {
  return `${url}${params}`
}
const link = (product: any) => {
  return `${product.url}`
}
</script>

<style src="~layers/app/components/Product/RelatedColorProducts.css" />
